export default "__VITE_ASSET__Dip_3Uog__"